import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";

const DrugTherapy = React.lazy(() => import("."));

function DrugTherapyLazyLoadWrapper(props) {
  const {DrugTherapyLoader, drugsCountTotal, Fullscreen,Highcharts,immunooptions,drugsCount,recistCriteriaTotal,
    treatmentResponse, recistCriteria,targetedTherapyTotal,targtedDrugoptions,targetedTherapy  } = props;
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
            //  DrugTherapyAPICall();
          observer.disconnect(); 
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  /* eslint-disable-next-line react-hooks/exhaustive-deps */  
  }, []);
  return (
    <Fragment>
    <div ref={containerRef} 
    // style={{ minHeight: "500px" }}
    >
        {isVisible && (
           <Suspense fallback={<ShimmerLoader />}>
            {DrugTherapyLoader === true && <ShimmerLoader />}

            {DrugTherapyLoader === false && immunooptions && treatmentResponse && targetedTherapy &&
 
            <DrugTherapy
              drugsCountTotal={drugsCountTotal}
              Fullscreen={Fullscreen}
              Highcharts={Highcharts}
              immunooptions={immunooptions}
              drugsCount={drugsCount}
              recistCriteriaTotal={recistCriteriaTotal}
              treatmentResponse={treatmentResponse}
              recistCriteria={recistCriteria}
              targetedTherapyTotal={targetedTherapyTotal}
              targetedTherapy ={targetedTherapy}
              targtedDrugoptions ={targtedDrugoptions}
            />}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default DrugTherapyLazyLoadWrapper;
